import React, { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const AgeVerification = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Vérifier si l'âge a déjà été vérifié
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowModal(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShowModal(false);
  };

  const handleDecline = () => {
    // Rediriger vers une page d'information ou simplement fermer
    window.location.href = 'https://www.joueurs-info-service.fr/';
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-2xl border-2 border-pink-600 max-w-md w-full p-8 relative">
        <div className="flex items-center justify-center mb-6">
          <div className="w-16 h-16 bg-pink-600 rounded-full flex items-center justify-center">
            <AlertTriangle className="text-white" size={32} />
          </div>
        </div>
        
        <h2 className="text-3xl font-bold text-white text-center mb-4">
          Vérification d'Âge
        </h2>
        
        <p className="text-gray-300 text-center mb-6 leading-relaxed">
          Ce site est réservé aux personnes majeures. Vous devez avoir au moins 18 ans pour accéder à ce contenu.
        </p>
        
        <p className="text-gray-400 text-sm text-center mb-8">
          En confirmant, vous certifiez que vous êtes majeur(e) et que vous acceptez les conditions d'utilisation de notre site.
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={handleDecline}
            className="flex-1 px-6 py-3 bg-gray-700 text-white rounded-lg font-semibold hover:bg-gray-600 transition-colors"
          >
            Non, j'ai moins de 18 ans
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 px-6 py-3 bg-gradient-to-r from-pink-600 to-pink-700 text-white rounded-lg font-semibold hover:from-pink-700 hover:to-pink-800 transition-all shadow-lg shadow-pink-500/50"
          >
            Oui, j'ai 18 ans ou plus
          </button>
        </div>

        <p className="text-gray-500 text-xs text-center mt-6">
          Le paris en ligne est interdit aux mineurs. Jouez de manière responsable.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

